@if (entity$ | async) {
  <div class="flex items-center justify-end mt-2">
    <ng-container *ngTemplateOutlet="createButton; context: { $implicit: 'Log Call', type: 'Call' }"></ng-container>
    <ng-container
      *ngTemplateOutlet="createButton; context: { $implicit: 'Log Meeting', type: 'Meeting' }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="createButton; context: { $implicit: 'Log Social Media', type: 'Social Media' }"
    ></ng-container>
  </div>
  <ng-container>
    <div class="flex flex-col w-full">
      <div class="note-list">
        <engagements-crm-panel [engagements]="engagements$ | async"></engagements-crm-panel>
      </div>
    </div>
  </ng-container>
  <ng-template #createButton let-label let-type="type">
    <ts-button
      [appAuthorize]="NewPermission.ENGAGEMENTS_CREATE"
      denyAction="disable"
      variant="primary"
      (click)="openEngagementModal(type)"
      class="mr-1"
    >
      <ts-icon icon="add"></ts-icon>
      <span class="ml-2">{{ label }}</span>
    </ts-button>
  </ng-template>
}
